<template>
    <div class="secondary-c tw-flex tw-flex-col">

        <div class=" tw-w-28 tw-h-28 tw-rounded tw-relative tw-block  tw-mb-4 tw-mx-auto">
            <img alt="" title="Chris Snoek" :src="profileSettings.avatar" class="tw-rounded">
            <i aria-hidden="true"
                class="far fa-pencil  tw-absolute tw-top-0 tw-right-0 tw-hidden tw-m-2 tw-text-white tw-p-3 tw-rounded tw-bg-black tw-bg-opacity-50 group-hover:tw-visible"></i>
        </div>

        <div class="tw-flex tw-justify-center">
            <div class="tw-mr-4">
                <image-uploader :return_file="true" :width="250" :height="250" :display="false" @upload="saveAvatar"
                    @close="closeAvatarUploader" v-if="changing_avatar"></image-uploader>
                <div role="button" class="subtle-button tw-bg-gray-100 tw-text-gray-700 tw-text-sm tw-flex"
                    @click="openAvatarUploader">
                    <p class="tw-whitespace-nowrap">{{ $t('groups.edit_image') }}</p>
                    <i class="far fa-image tw-h-2"></i>
                </div>
            </div>

            <div class="subtle-button tw-bg-gray-100 tw-text-gray-700 tw-text-sm tw-flex">
                <div v-if="profileSettings.avatar === 'facebook'">
                    <i class="fa fa-check tw-mr-2"></i>
                    <p>{{ $t('profile.connected_with_fb') }}</p>
                </div>
                <a v-else class="profile-fb-btn inline-block hover-opacity"
                    href="/auth/redirect/facebook?location=avatar">
                    {{ $t('profile.connect_with_fb') }}
                    <i class="fab fa-facebook-square tw-mr-2"></i>
                </a>
            </div>

        </div>

    </div>
</template>

<script>
import Global from '../../../mixins/Global'
import ImageUploader from '../../ui/ImageUploader';
import Notification from '../../../lib/models/Notification';
import axios from 'axios';
export default {
    name: 'AvatarTab',
    mixins: [Global],

    components: {
        'image-uploader': ImageUploader
    },
    props: ['profileSettings'],
    data() {
        return {
            changing_avatar: false,
        }
    },
    methods: {
        openAvatarUploader() {
            this.changing_avatar = true;
        },
        closeAvatarUploader() {
            this.changing_avatar = false;
        },
        saveAvatar(data) {
            const formData = new FormData();
            formData.append('avatar', data.blob, data.filename);
            axios.post('/api/v3/profile/me/avatar', formData).then((response) => {
                const new_profile = response.data.data;
                new_profile.birth_date = moment(new_profile.birth_date, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD');
                HuddleUser.create({ data: new_profile });
                Notification.insert({
                    data: [
                        {
                            title: this.$t('profile.settings_saved'),
                        },
                    ],
                });
            }).catch(() => {
                Notification.insert({
                    data: [
                        {
                            title: this.$t('profile.settings_saved_failed'),
							status: 'error',
                        },
                    ],
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.subtle-button {
    @apply tw-rounded tw-font-semibold tw-text-gray-700 tw-text-center tw-select-none tw-appearance-none tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-p-3;
    transition: background .15s, color .15s;
}
</style> 
